import Cookies from 'universal-cookie';
import { SET_REPORT_FILTER } from '../actions/reportfilterAction'
import dayjs from 'dayjs';
import { getDateRange } from '../utils/utils';

const cookies = new Cookies();
const cookiesReportFilter = "ReportFilter";

const defaultState = {
  fromDate: dayjs(new Date(dayjs().year(), 0, 1, 0, 0)),
  toDate: dayjs().add(1, 'day'),
  period: 'thisYear',
  color: null,
  duplex: null,
};

function getInitialState() {
  const saved = cookies.get(cookiesReportFilter);

  if (!saved) {
    return defaultState;
  }

  if (saved.period !== 'custom')
  {
    const range = getDateRange(saved.period);
    saved.fromDate = range.fromDate;
    saved.toDate = range.toDate;
  }

  try {
    return {
      ...defaultState,
      ...saved,

      // ВАЖНО: превращаем строки обратно в dayjs
      fromDate: saved.fromDate ? dayjs(saved.fromDate) : defaultState.fromDate,
      toDate: saved.toDate ? dayjs(saved.toDate) : defaultState.toDate,
    };
  } catch (e) {
    console.warn("Bad ReportFilter cookie:", e);
    return defaultState;
  }
}

const initialState = getInitialState();
  
  export function reportFilterReducer(state = initialState, action) {
    switch (action.type) {
        case SET_REPORT_FILTER:
            cookies.set(
              cookiesReportFilter,
              {
                period: action.payload.period,
                color: action.payload.color,
                duplex: action.payload.duplex,
                fromDate: action.payload.fromDate?.toISOString(),
                toDate: action.payload.toDate?.toISOString(),
              },
              { maxAge: 60 * 60 * 24 * 365 }
            );
            return { ...state, ...action.payload };
        default:
            return state;
    }
  }